<template>
<div>
    <div class="col-md-12">
        <div class="row" style="margin-top:20px">
            <div class="col-md-6">
                <h3 class="page-header">
                <i class="bx bx-send animated bounceInDown show-info"></i>
                New Complaint
                </h3>
            </div>
        </div>
    </div>
    <div class="flex-row">
        <div class="col-md-12">
            <div class="panel panel-cascade">
                <div class="info-box bg-primary text-white">
                    <div class="info-icon bg-warning-dark">
                        <i class="fa fa fa-user fa-2x"></i>
                    </div>
                    <div class="info-details">
                        <h4>Complaint Details</h4>
                    </div>
                </div>
                <div class="panel-body" style="min-height:550px">
                    <div class="form-horizontal cascde-forms">
                        <div class="form-group flex-row">
                            <label class="col-lg-4 col-md-3 control-label">Customer VSDIGI ID<span style="color:red">*</span> </label>
                            <div class="col-lg-8 col-md-9">
                                <div class="input-group">
                                    <span class="input-group-text">VSDIGI-</span>
                                    <input class="form-control form-cascade-control input-small" v-model="customername" type="text" inputmode="numeric" pattern="[0-9]*" placeholder="Enter ID number" @input="getUser()"/>
                                </div>
                                <p v-if="founduser!=null">{{ founduser.name}}</p>
                                <p v-if="usernotfound" style="color:red">Customer Not Found</p>
                            </div>
                        </div>
                        <div class="form-group flex-row" v-if="founduser!=null && founduser.id">
                            <label class="col-lg-4 col-md-3 control-label">Purchased Product / Serial No.</label>
                            <div class="col-lg-8 col-md-9">
                                <select class="form-control form-cascade-control input-small" v-model="purchasekey" @change="selectPurchase()">
                                    <option value="">{{ loadingpurchases ? 'Loading…' : '---Select---' }}</option>
                                    <option v-for="row in purchases" :key="purchaseKey(row)" :value="purchaseKey(row)">
                                        {{ row.productname || 'Product #' + row.productid }}{{ row.serialno ? ' · S/N ' + row.serialno : '' }} · {{ formatDate(row.transactiondate) }}
                                    </option>
                                    <option value="other">Other product (not in this customer's purchases)</option>
                                </select>
                                <small v-if="!loadingpurchases && !purchases.length" class="text-muted">No purchases found for this customer. Choose the product below.</small>
                            </div>
                        </div>
                        <template v-if="showProductPicker">
                        <div class="form-group row">
                            <div class="col-lg-4 col-md-3">
                                <label for="subcategory" class="col-form-label control-label">Select Category</label>
                            </div>
                            <div class="col-lg-8 col-md-9">
                                <select class="form-control form-cascade-control input-small" v-model="parentid" ref="myInput">
                                    <option selected>----Select-----</option>
                                    <option v-for="item in parentcategory" v-bind:value="item.id" :key="item.id">{{item.name}}</option>
                                </select>
                                <span class="invalid-feedback" role="alert">
                                    <strong></strong>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-4 col-md-3">
                                <label for="subcategory" class="col-form-label control-label">Select Product</label>
                            </div>
                            <div class="col-lg-8 col-md-9">
                                <select @change="fetchbrands()" class="form-control form-cascade-control input-small" v-model="category_id">
                                <option selected>----Select-----</option>
                                <option v-for="item in subcategory" v-bind:value="item.id" :key="item.id">{{item.name}}</option>
                                </select>
                                <span class="invalid-feedback" role="alert">
                                    <strong></strong>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class=" col-lg-4 col-md-3">
                                <label for="subcategory" class="col-form-label control-label">Company</label>
                            </div>
                            <div class="col-lg-8 col-md-9">
                                <select v-model="brandid" @change="fetchproducts()" class="form-control form-cascade-control input-small" >
                                    <option value="0">---Select---</option>
                                    <option v-for="filter in brands" :key="filter.id" :value="filter.id">{{filter.value}}</option>
                                </select>
                                <span class="invalid-feedback" role="alert">
                                    <strong></strong>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-4 col-md-3">
                                <label for="firstname" class="col-form-label control-label">Model Name<span style="color: rgba(255, 0, 0, 0.67)">*</span></label>
                            </div>
                            <div class="col-lg-8 col-md-9">
                                <select v-model="productid" class="form-control form-cascade-control input-small" >
                                    <option v-for="filter in products" :key="filter.id" :value="filter.id">{{filter.name}}</option>
                                </select>
                            </div>
                        </div>
                        </template>
                        <div class="form-group flex-row" v-if="duplicateChecking || openDuplicateComplaint || duplicateCheckError">
                            <div class="col-lg-4 col-md-3"></div>
                            <div class="col-lg-8 col-md-9">
                                <div v-if="duplicateChecking" class="alert alert-info complaint-duplicate-message">
                                    Checking for an existing complaint for this product...
                                </div>
                                <div v-else-if="openDuplicateComplaint" class="alert alert-danger complaint-duplicate-message">
                                    Complaint <strong>#{{ openDuplicateComplaint.complaintno || openDuplicateComplaint.id }}</strong>
                                    for this customer and product is not disposed yet
                                    ({{ complaintStatusLabel(openDuplicateComplaint) }}).
                                    Dispose the old complaint before creating a new one.
                                </div>
                                <div v-else-if="duplicateCheckError" class="alert alert-warning complaint-duplicate-message">
                                    {{ duplicateCheckError }}
                                </div>
                            </div>
                        </div>
                        <div class="form-group flex-row">
                            <label class="col-lg-4 col-md-3 control-label">Complaint Description</label>
                            <div class="col-lg-8 col-md-9">
                                <textarea class="form-control form-cascade-control input-small" cols="20" v-model="remark" rows="2">
                                </textarea>
                            </div>
                        </div>
                        <div class="form-group flex-row">
                            <label class="col-lg-4 col-md-3 control-label">Date of Purchase<span style="color:red">*</span> </label>
                            <div class="col-lg-8 col-md-9" v-if="selectedpurchase">
                                <p style="margin:6px 0">
                                    Date of sale: <strong>{{ formatDate(selectedpurchase.transactiondate) }}</strong>
                                    <span v-if="selectedpurchase.invoiceno"> · Bill No. {{ selectedpurchase.invoiceno }}</span>
                                    · <a href="javascript:void(0)" @click="viewBill(selectedpurchase.saletransactionid)">View bill</a>
                                </p>
                            </div>
                            <div class="col-lg-8 col-md-9" v-else>
                                <input type="date" class="form-control form-cascade-control input-small" v-model="leaddate">
                                <!-- <vc-date-picker class="inline-block h-full" :model-config="modelConfig" >
                                    <template v-slot="{ inputValue, togglePopover }">
                                        <div class="flex items-center">
                                            <button type="button"
                                                class="date-picker"
                                                @click="togglePopover()">
                                                <i class='bx bx-calendar'></i>
                                            </button>
                                            <input :value="inputValue" @click="togglePopover()"
                                                class="form-control form-cascade-control input-small"
                                                placeholder="DD/MM/YYYY" readonly />
                                        </div>
                                    </template>
                                </vc-date-picker> -->
                            </div>
                        </div>
                        <!-- <div class="form-group flex-row" v-if="loggedinuser?.role>=2">
                            <label class="col-lg-4 col-md-3 control-label">Followed By<span style="color:red">*</span></label>
                            <div class="col-lg-8 col-md-9">
                                <select v-model="followedid" class="form-control form-cascade-control input-small">
                                    <option v-for="filter in employees" :key="filter.id" :value="filter.id">{{filter.name}}</option>
                                </select>             
                                <font color="red"><span class="field-validation-valid" data-valmsg-for="FOLLOWEDBYID" data-valmsg-replace="true"></span></font>
                            </div>
                        </div>-->
                        <div style="display:none" class="form-group flex-row" v-if="loggedinuser?.role<2">
                            <label class="col-lg-4 col-md-3 control-label">Followed By<span style="color:red">*</span></label>
                            <div class="col-lg-8 col-md-9">
                                <select v-model="followedid" class="form-control form-cascade-control input-small">
                                    <option v-for="filter in employees.filter(property => property.id ==loggedinuser.id )" :key="filter.id" :value="filter.id" ><span >{{filter.name}}</span></option>
                                </select>             
                                <font color="red"><span class="field-validation-valid" data-valmsg-for="FOLLOWEDBYID" data-valmsg-replace="true"></span></font>
                            </div>
                        </div> 
                          <!--  <div class="form-group flex-row">
                            <label class="col-lg-4 col-md-3 control-label">Request<span style="color:rgba(255, 0, 0, 0.67)">*</span></label>
                            <div class="col-lg-8 col-md-9">
                                <select class="form-control form-cascade-control input-small" v-model="requesttype">
                                    <option value="2">COMPLAINT</option>
                                </select>
                                <font color="red"><span class="field-validation-valid" data-valmsg-for="REQUEST" data-valmsg-replace="true"></span></font>
                            </div>
                        </div> -->
                </div>
            </div>
        </div>
        <!-- <div class="col-md-6">
            <div class="panel panel-cascade">
                <div class="info-box bg-primary text-white">
                    <div class="info-icon bg-warning-dark">
                        <i class="fa fa fa-user fa-2x"></i>
                    </div>
                    <div class="info-details">
                        <h4>Details</h4>
                    </div>
                </div>
                <div class="panel-body" style="height:300px">
                    <div class="form-horizontal cascde-forms">
                        
                        </div>
                        <div class="form-group flex-row">
                            <label class="col-lg-4 col-md-3 control-label">Lead By<span style="color:rgba(255, 0, 0, 0.67)">*</span></label>
                            <div class="col-lg-8 col-md-9">
                                <select class="form-control form-cascade-control input-small" v-model="leadtype" name="WALKIN"><option value="0">SELECT</option>
                                    <option value="1">INCOMING CALL</option>
                                    <option value="2">OUTGOING CALL</option>
                                    <option value="3">NEWS PAPER ADD</option>
                                    <option value="4">SHOW ROOM WALKIN</option>
                                    <option value="5">HOME VISIT</option>
                                    <option value="6">REFFERRED BY OTHER</option>
                                    <option value="7">INTERNET</option>
                                    <option value="8">BY ADVISOR</option>
                                </select>
                            </div>
                        </div>
                        </div>
                    </div>
                </div> -->
            <!-- </div> -->
        </div>
        <div class=" col-md-12 text-center">
            <input type="submit" :value="submitting ? 'Submitting...' : 'Submit'" style="width:20%" class="btn bg-primary text-white btn-md" :disabled="submitting || duplicateChecking || !!openDuplicateComplaint" @click="submit()">
        </div>
        
    </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { openBill, billError } from './complaintBill'
// import ReferralSelector from '../../components/user/ReferralSelector.vue'
// import { required, maxLength,minLength } from 'vuelidate/lib/validators'
export default{
    components:{},
    data(){
        return{
            followedid:'',
            requesttype:2,
            remark:'',
            leadtype:0,
            id:0,
            leaddate:'',
            modelConfig: {
                type: 'string',
                mask: 'YYYY-MM-DD', // Uses 'iso' if missing
            },
            usernotfound:false,
            customername:'',
            founduser:null,
            brandid:0,
            products:[],
            parentid:0,
            category_id:0,
            brands:[],
            productid:0,
            // The customer's purchases, loaded once a customer is found.
            purchases:[],
            loadingpurchases:false,
            purchasekey:'',
            duplicateChecking:false,
            duplicateCheckError:'',
            openDuplicateComplaint:null,
            duplicateRequestId:0,
            submitting:false,
        }
    },
    validations:{
        
    },
    computed:{
        ...mapGetters(['employees','referraluser','loggedinuser','categories']),
        parentcategory(){
            if(this.categories!=null){
                return this.categories.filter(block=>block.parent_id==0)
            }
            return [];
        },
        subcategory(){
            if(this.categories!=null){
                return this.categories.filter(block=>block.parent_id==this.parentid)
            }
            return [];
        },
        /*brands(){
            let attribute = this.attributes.find(block=>block.id==2)
            return attribute
        },*/
        predefinedvalues(){
            if(this.brands!=null && this.brands.predefinedvalues!=null){
                return this.brands.predefinedvalues
            }
            return [];
        },
        getval(value){
            return value
        },

        filters(){
            return this.categories.filter(item => item.parent_id != 0 && item.parent_id != null)
        },
        selectedpurchase(){
            if(this.purchasekey==='' || this.purchasekey==='other') return null
            return this.purchases.find(row=>this.purchaseKey(row)===this.purchasekey) || null
        },
        // The category / company / model picker is for products not bought by this customer.
        showProductPicker(){
            return !this.selectedpurchase
        },
        selectedproduct(){
            if(this.products!=null){
                return  this.products.find(block=>block.id==this.productid)
            }
            return [];
        },
    },
    mounted(){
        this.refresh();
    },
    watch:{
        productid(){
            this.checkOpenDuplicateComplaint().catch(() => {})
        },
        founduser(){
            this.checkOpenDuplicateComplaint().catch(() => {})
        },
    },
    methods:{
        getUser(){
            this.customername = String(this.customername || '').replace(/\D/g, '')
            const numericId = this.customername
            this.processGetUSerResponse(null)
            this.usernotfound = false
            if(!numericId) return
            const param = {generatedid:`VSDIGI-${numericId}`}
            this.$http.post('api/user/getuserbygeneratedid',param)
            .then((response) => {
                if(this.customername !== numericId) return
                this.processGetUSerResponse(response.data)
                this.usernotfound = !response.data
            })
            .catch((err) => {
                console.log(err)
            });
        },
        processGetUSerResponse(data){
            const previousid = this.founduser?.id
            this.founduser = data || null
            if(this.founduser?.id !== previousid){
                this.loadPurchases()
            }
        },
        purchaseKey(row){
            return row.saleitemid + ':' + (row.serialno || '')
        },
        loadPurchases(){
            this.purchases = []
            this.purchasekey = ''
            this.selectPurchase()
            const customerid = this.founduser?.id
            if(!customerid) return
            this.loadingpurchases = true
            this.$http.post('api/vsdigi/complaints/customer-products',{customerid})
            .then((response) => {
                // Ignore a reply for a customer who is no longer selected.
                if(this.founduser?.id === customerid) this.purchases = response.data.data || []
            })
            .catch((err) => console.log(err))
            .finally(() => { this.loadingpurchases = false })
        },
        selectPurchase(){
            const row = this.selectedpurchase
            this.productid = row ? row.productid : 0
            this.leaddate = row ? moment(row.transactiondate).format('YYYY-MM-DD') : ''
        },
        viewBill(saletransactionid){
            openBill(saletransactionid).catch((err) => this.$notify({text:billError(err),type:'error'}))
        },
        formatDate(value){
            return value ? moment(value).format('DD-MM-YYYY') : 'N.A'
        },
        complaintStatus(item){
            if(item?.complaint_status) return String(item.complaint_status).toLowerCase()
            if(item?.isdispose == 1) return 'disposed'
            if(item?.iscancelled == 1) return 'cancelled'
            if(item?.status == 1) return 'resolved'
            return item?.scheduledate ? 'scheduled' : 'launched'
        },
        complaintStatusLabel(item){
            const status = this.complaintStatus(item)
            return status.charAt(0).toUpperCase() + status.slice(1)
        },
        async checkOpenDuplicateComplaint(){
            const customerid = Number(this.founduser?.id || 0)
            const productid = Number(this.productid || 0)
            const requestId = ++this.duplicateRequestId

            this.openDuplicateComplaint = null
            this.duplicateCheckError = ''
            if(!customerid || !productid){
                this.duplicateChecking = false
                return null
            }

            this.duplicateChecking = true
            try{
                const response = await this.$http.post('api/vsdigi/complaints/open-duplicate', {
                    customerid,
                    productid,
                })
                if(requestId !== this.duplicateRequestId) return null
                const match = response.data.data || null

                if(requestId === this.duplicateRequestId) this.openDuplicateComplaint = match
                return match
            }catch(err){
                if(requestId === this.duplicateRequestId){
                    this.duplicateCheckError = err?.response?.data?.message || 'Could not check existing complaints. Please try again.'
                }
                throw err
            }finally{
                if(requestId === this.duplicateRequestId) this.duplicateChecking = false
            }
        },
        refresh(){
            this.$store.dispatch('fetchemployees')     
            this.$store.dispatch("fetchproducts")
            this.$store.dispatch('fetchcategorieslite')
            this.$store.dispatch('fetchattributes')                                                             
        },
        initializedata(){
            this.followedid='',
            this.customername='',
            this.requesttype=2,
            this.remark='',
            this.leadtype=0,
            this.leaddate='',
            this.founduser=null
            this.purchases=[]
            this.purchasekey=''
            this.productid=0
            this.openDuplicateComplaint=null
            this.duplicateCheckError=''
        },
        async submit(){
            if(this.submitting) return
            if(!this.founduser?.id){
                this.$notify({text:'Select the customer by VSDIGI ID',type:'error'})
            }else if(!this.productid){
                this.$notify({text:'Select the complaint product',type:'error'})
            }else if(!this.$v.$invalid){
                let duplicate
                try{
                    duplicate = await this.checkOpenDuplicateComplaint()
                }catch(err){
                    this.$notify({text:this.duplicateCheckError,type:'error'})
                    return
                }
                if(duplicate){
                    this.$notify({
                        text:`Complaint #${duplicate.complaintno || duplicate.id} for this customer and product must be disposed first`,
                        type:'error'
                    })
                    return
                }

                const purchase = this.selectedpurchase
                let param = {followedid:this.followedid||0,
                            customerid:this.founduser.id,
                            remark:this.remark,
                            leaddate:this.leaddate||null,
                            productid:this.productid||0,
                            saletransactionid:purchase ? purchase.saletransactionid : null,
                            serialno:purchase ? purchase.serialno : null
                }
                this.submitting = true
                this.$store.commit('assignloadingstatus',1)
                this.$http.post('api/vsdigi/complaints/create',param)
                .then((response) => this.processLeadResponse(response.data))
                .catch((err) => {
                    const errors = err?.response?.data?.errors
                    this.$notify({text:(errors && Object.values(errors)[0][0]) || err?.response?.data?.message || 'Could not save the complaint',type:'error'})
                })
                .finally(() => {
                    this.submitting = false
                    this.$store.commit('assignloadingstatus',0)
                })
            }else{
                this.$notify({text:'Please Avoid the Error Mention in the Form',type:'error'})
            }
        },
        processLeadResponse(){
            this.initializedata();
            this.$notify({text:'Submitted Successfully',type:'success'})
        },
        
        fetchbrands(){
            
            let param = {parentcategoryid:this.category_id,attributeid:2}
            window.axios.post('api/attribute/values/fetchbycategory',param)
    			.then(response=>this.processAvailableBrands(response.data))
    			.catch(error=>console.log(error));
        },
        processAvailableBrands(data){
            this.brands = data
        },
        fetchproducts(){
            
            let param = {parentcategoryid:this.category_id,attributeid:2,attributevalueids:this.brandid}
            window.axios.post('api/products/fetchbyfilters',param)
    			.then(response=>this.processProductsResponse(response.data))
    			.catch(error=>console.log(error));
        },
        processProductsResponse(data){
            this.products = data
        },
        
    }
}
</script>
<style>
.flex-row{
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
    flex-wrap: wrap;
}
.complaint-duplicate-message{
    margin: 0;
    padding: 10px 12px;
}
</style>
